import { Select, SelectProps } from "antd";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { WfControlProps } from "./ControlProps";
import ComponentLabel from "../../../../../../components/ControlComponents/ComponentLabel";

export function WfDropdown({
  layout,
  layoutLength,
  fieldState,
  inputProps,
}: Readonly<WfControlProps>) {
  return (
    <>
      <ComponentLabel
        colText={2}
        rowIdx={1}
        colIdx={0}
        template={layout.template}
      />
      <Col xs={12} lg={layoutLength === 1 ? 10 : 4}>
        <Select showSearch={true} {...(inputProps as SelectProps)}>
          {layout.template?.attribute?.items?.map((item, i) => (
            <Select.Option key={item.value ?? item.label ?? item.item}>
              {item.label ?? item.item}
            </Select.Option>
          ))}
        </Select>
        {fieldState.error && (
          <>
            <small className="text-danger">{fieldState.error.message}</small>
          </>
        )}
      </Col>
    </>
  );
}
